import React from 'react'

function SLProfile() {
  return (
    <div>SLProfile</div>
  )
}

export default SLProfile